import { render } from "./x.vue?vue&type=template&id=fd4863f6&scoped=true"
import script from "./x.vue?vue&type=script&lang=js"
export * from "./x.vue?vue&type=script&lang=js"

import "./x.vue?vue&type=style&index=0&id=fd4863f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd4863f6"]])

export default __exports__